import React, {Fragment, useEffect, useState} from 'react'
import Counter from "../../../components/counter";

export default function ScreenBarPartner({context, campagneData, mini}){

    const partnerMontant = campagneData?.partnerMontant || 1
    const total = campagneData.stats.total.sum.total / partnerMontant

    let bonus = null
    let _objectif = campagneData.objectif
    if(_objectif < total && Array.isArray(campagneData?.bonus) && campagneData?.bonus.length > 0){
        bonus = campagneData.bonus.find(b => b > total)
        if(!bonus){
            bonus = campagneData.bonus.at(-1)
        }
    }
    if(bonus){
        _objectif = bonus
    }

    const percent = Math.min(100, (_objectif>0 ? (total / _objectif) * 100 : 0))
    const displayPercent = (Number(campagneData.objectif)>0 ? (total / campagneData.objectif) * 100 : 0)

    return (
        <Fragment>
            <div style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "1vh",
                width: "100%",
            }}>

                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    lineHeight: 1,
                }}>
                    <span style={{
                        textAlign: "center",
                        fontFamily: "Gravesend-Titre, serif",
                        fontSize: "34vh",
                        color: "#dcc3b6",
                        lineHeight: 1,
                        letterSpacing: "0.02em",
                        fontWeight: 700,
                        textShadow: "0 4px 14px rgba(0,0,0,0.35)",
                    }}>
                        <Counter number={total} decimals={0} preserveValue/>
                    </span>
                </div>

                <div style={{
                    marginTop: "11vh",
                    backgroundColor: "#FFF",
                    padding: 0,
                    height: "4.2vh",
                    width: "42vw",
                    borderRadius: 2,
                    border: "1px solid rgba(220,195,182,0.7)",
                    boxShadow: "0 2px 14px rgba(0,0,0,0.35)",
                    position: "relative",
                    overflow: "hidden",
                    boxSizing: "border-box",
                }}>
                    <div style={{
                        width: percent + "%",
                        height: "100%",
                        background: "#dcc3b6",
                        transition: "width 1s ease",
                    }}/>

                    <span style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontFamily: "Gravesend-Bold, sans-serif",
                        fontSize: "2.4vh",
                        color: "#162c4a",
                        letterSpacing: "0.05em",
                        pointerEvents: "none",
                    }}>
                        {Math.floor(displayPercent)}%
                    </span>
                </div>
            </div>
        </Fragment>
    )
}


const FlipCountdown = ({ targetDateTime }) => {
    const [timeLeft, setTimeLeft] = useState(getTimeLeft());

    function getTimeLeft() {
        const now = new Date();
        const target = new Date(targetDateTime);
        const total = Math.max(0, Math.floor((target - now) / 1000));
        const minutes = Math.floor(total / 60).toString().padStart(2, '0');
        const seconds = (total % 60).toString().padStart(2, '0');
        return { minutes, seconds };
    }

    useEffect(() => {
        const interval = setInterval(() => {
            setTimeLeft(getTimeLeft());
        }, 1000);
        return () => clearInterval(interval);
    }, [targetDateTime]);

    const digitStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '60px',
        height: '80px',
        backgroundColor: '#f9b233',
        background:"linear-gradient(0deg,rgba(185, 144, 94, 1) 0%, rgba(239, 220, 167, 1) 50%)",
        color: '#162c4a',
        fontSize: '3rem',
        fontWeight: 'bold',
        textAlign: 'center',
        lineHeight: '60px',
        margin: '2px',
        borderRadius: '5px',
        fontFamily: 'monospace',
    };

    const renderDigits = (digits) =>
        digits.split('').map((d, idx) => (
            <div key={idx} style={digitStyle}>
                {d}
            </div>
        ));

    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            {renderDigits(timeLeft.minutes)}
            <div style={{ fontSize: '2.5rem', margin: '0 5px', color: '#fff' }}>:</div>
            {renderDigits(timeLeft.seconds)}
        </div>
    );
};
